module.exports = __webpack_public_path__ + "img/full2-min.88fc13b2.png";